import {twMerge} from '@sdox/utils'

import {Center} from '../Center'

import type {ComponentProps} from 'react'
import './LoadingStyles.css'

export interface LoadingProps extends ComponentProps<'div'> {
  label?: string | null
  color?: string
  pulse?: boolean
  newStyle?: boolean
}

const LoadingSkeleton = ({className}: Pick<LoadingProps, 'className'>) =>
  <div className={twMerge('animate-pulse bg-gray-300', className)}></div>

const LoadingV2 = ({
  className,
  color = 'text-black',
  // label = 'Laden ...',
  pulse = true,
  ...restProps
}: LoadingProps) => (
  <div
    className={twMerge(' flex flex-col items-center justify-center', color, className)}
    data-cy={'loading'}
    {...restProps}
  >
    <svg
      xmlns={'http://www.w3.org/2000/svg'}
      viewBox={'0 0 557.18 600.69'}
    >
      <path
        className={twMerge('fill-sdox-primary', pulse && 'animate-pulse-slow')}
        d={'M532.77,600.69h-165.56l-97.64-174.05-101.88,174.05H0L180.42,316.27,10.61,48.82H169.81l95.52,166.62L371.45,37.15C383.13,11.67,404.35,0,433.01,0h124.17l-206.95,318.39,182.54,282.31Z'}
      />
    </svg>
    <div className={'relative mt-5 h-3 w-full overflow-hidden'}>
      <div className={'absolute left-0 top-0 size-full animate-progress-sdox bg-[#2d9bf0]'} />
    </div>
  </div>
)

const LoadingLegacy = ({
  className,
  color = 'text-black',
  label = 'Laden ...',
  // pulse = true,
  ...restProps
}: LoadingProps) => (
  <div
    className={twMerge('flex flex-col items-center justify-center', color, className)}
    data-cy={'loading'}
    {...restProps}
  >
    <div className={twMerge('loader loader-bars', label && 'mb-4')}>
      <span />
    </div>
    {label && <h4 className={'whitespace-pre-wrap text-center'}>{label}</h4>}
  </div>
)

const Bar = ({className, label = 'Laden ...', color = 'text-white', ...restProps}: LoadingProps) => (
  <div
    className={twMerge(
      'flex animate-pulse items-center justify-center bg-gradient-to-r from-sdox-primary via-sdox-accent to-sdox-primary',
      className,
    )}
    data-cy={'loading'}
    {...restProps}
  >
    <span className={twMerge(color, 'whitespace-pre-wrap py-2')}>{label}</span>
  </div>
)

const Fullscreen = () => (
  <Center className={'h-screen w-screen'}>
    <LoadingLegacy />
  </Center>
)

export const Loading = Object.assign(LoadingLegacy, {
  V2: LoadingV2,
  Bar,
  Fullscreen,
  Skeleton: LoadingSkeleton,
})
